import { ViteReactSSG } from 'vite-react-ssg';
import routes from './router/config';
import './i18n';
import './index.css';

// Self-hosted Montserrat (weights used across the legacy design: /start-free, legals).
import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/montserrat/300-italic.css';
import '@fontsource/montserrat/400-italic.css';

// Self-hosted Schibsted Grotesk (headings) + Hanken Grotesk (body) for the 2026
// site redesign (Hub + product pages). Family names match the inline styles.
import '@fontsource/schibsted-grotesk/400.css';
import '@fontsource/schibsted-grotesk/500.css';
import '@fontsource/schibsted-grotesk/600.css';
import '@fontsource/schibsted-grotesk/700.css';
import '@fontsource/schibsted-grotesk/800.css';
import '@fontsource/hanken-grotesk/400.css';
import '@fontsource/hanken-grotesk/500.css';
import '@fontsource/hanken-grotesk/600.css';
import '@fontsource/hanken-grotesk/700.css';

// ViteReactSSG bootstraps the router for both the static pre-render (Node)
// and the client (hydration). No <BrowserRouter> / createRoot needed here.
export const createRoot = ViteReactSSG({
  routes,
  basename: import.meta.env.BASE_URL,
});
